import { useLayoutEffect, useState } from 'react'

import { useMemoizedFn } from 'ahooks'
import { Tabs } from 'antd'

import { useAutorizedItems } from '@eastcoal/auth/hooks/useAuthorizedItems'
import { useLocation, useNavigate } from '@eastcoal/router/exports/react-router'

import { ProTabsProps } from './interface'

/**
 * 1. 支持权限控制
 * 2. 支持路由联动
 */
export const ProTabs = ({
  items,
  defaultActiveKey,
  activeKey,
  onChange,
  ...restProps
}: ProTabsProps) => {
  const location = useLocation()
  const authorizedItems = useAutorizedItems(items)

  const externalValue = activeKey ?? defaultActiveKey
  const innerValue = location.hash.slice(1) || externalValue

  const [value, setValue] = useState(innerValue)
  const triggerChange = useMemoizedFn((newValue: string) => {
    setValue(newValue)
    onChange?.(newValue)
  })

  useLayoutEffect(() => {
    if (innerValue && innerValue !== externalValue) {
      triggerChange(innerValue)
    }
  }, [externalValue, innerValue, triggerChange])

  const navigate = useNavigate()
  const handleTabChange = (key: string) => {
    triggerChange(key)
    navigate(`${location.pathname}${location.search}#${key}`)
  }

  return (
    <Tabs
      {...restProps}
      activeKey={value}
      items={authorizedItems}
      onChange={handleTabChange}
    />
  )
}
